import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get } from 'lodash';
import React from 'react';
import { OriCheckbox, OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveModuleStyle,
  ResponsiveText,
} from 'src/components/Modules/Components';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import Switcher from 'src/components/SectionSwitcher';
import { errKeys } from 'src/constrains/DraggableModules/tools';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import AutoPlay from 'src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EModuleWidth,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveProductToShow,
} from 'src/types/common/module';
import css from './css.module.less';
const Option = OriSelect.Option;

const ResponsiveProductCarousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visible, setVisible] = React.useState(false);
  //console.log(props);
  const {
    onItemReselect,
    onItemDelete,
    onItemSort,
    onStaticChange,
    products,
    specificError,
    staticData,
    animations,
    hoverAnimations,
    buttons,
    isConvertible,
  } = props;

  //console.log('isConvertible', isConvertible);

  const draggableId = get(staticData, 'draggableId');
  const productToShow = get(staticData, 'productToShow');
  const animation = get(staticData, 'animation');
  const autoPlay = get(staticData, 'autoPlay');
  const intervalTime = get(staticData, 'intervalTime');
  const moduleStyle = get(staticData, 'moduleStyle');
  const moduleWidth = get(staticData, 'moduleWidth');
  const leaveGap = get(staticData, 'leaveGap');
  const scrollOut = get(staticData, 'scrollOut');

  const actionButtonTheme = get(staticData, 'actionButtonTheme') || null;
  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const text = get(staticData, 'moduleText');
  const handleOnActionButtonThemeChange = (actionButtonTheme) => {
    onStaticChange({ actionButtonTheme });
  };

  const dict = {
    [EResponsiveProductToShow.One]: 1,
    [EResponsiveProductToShow.Two]: 2,
    [EResponsiveProductToShow.TwoLandscape]: 2,
    [EResponsiveProductToShow.TwoPortrait]: 2,
    [EResponsiveProductToShow.Three]: 3,
    [EResponsiveProductToShow.Four]: 4,
    [EResponsiveProductToShow.Five]: 5,
    [EResponsiveProductToShow.Six]: 6,
  };

  const generateScrolledOut = () => {
    const all = [
      <Option value={1} key={'1'}>
        One Product Each Scroll
      </Option>,
      <Option value={2} key={'2'}>
        Two Products Each Scroll
      </Option>,
      <Option value={3} key={'3'}>
        Three Products Each Scroll
      </Option>,
      <Option value={4} key={'4'}>
        Four Products Each Scroll
      </Option>,
      <Option value={5} key={'5'}>
        Five Products Each Scroll
      </Option>,
      <Option value={6} key={'6'}>
        Six Products Each Scroll
      </Option>,
    ];
    const mostNumber = dict[productToShow] || 0;
    const a = all.slice(0, mostNumber);
    return a;
  };

  const isOneProductOnScreen = productToShow === EResponsiveProductToShow.One;

  const shouldHideBkgColor = !(
    productToShow === EResponsiveProductToShow.One ||
    productToShow === EResponsiveProductToShow.TwoLandscape
  );
  const handleOnScrollOutChange = (scrollOut) => {
    onStaticChange({ scrollOut });
  };

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnAutoPlayChange = (autoPlay) => {
    onStaticChange({ autoPlay });
  };

  const handleOnIntervalChange = (intervalTime) => {
    onStaticChange({ intervalTime });
  };

  const handleOnProductToShowChange = (productToShow) => {
    const mostNumber = dict[productToShow];

    if (mostNumber && scrollOut > mostNumber) {
      onStaticChange({ productToShow, scrollOut: mostNumber });
    } else {
      onStaticChange({ productToShow });
    }

    // onStaticChange({ productToShow });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleOnItemReselect = (products) => {
    if (onItemReselect) {
      const _products = products.map((i) => {
        return { ...i, draggableId: i.uuid };
      });
      // console.log('_products', _products);
      //const item = generateResponsiveImage();
      //console.log('item', item);
      onItemReselect(_products);
    }
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const childGenerate = (data, index) => {
    const sku = get(data, 'sku');
    const name = get(data, 'productName');
    const thumbnailUrl = get(data, 'thumbnailUrl');
    return <ProductDisplayInRow sku={sku} name={name} img={thumbnailUrl} />;
  };

  const amountErr =
    specificError[
      `${errKeys.ResponsiveProductCarousel.productToShowMismatch}`
    ] || [];

  return (
    <React.Fragment>
      {visible && (
        <ProductSelection
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }}
          onOk={handleOnItemReselect}
          selectedProducts={products || []}
          disabledProducts={[]}
        />
      )}
      {!isConvertible && (
        <Section size='small' bottomBorder className={css.container}>
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
          <div className={css.autoContainer}>
            <AutoPlay
              isAuto={autoPlay}
              interval={intervalTime}
              interOnChange={handleOnIntervalChange}
              autoOnChange={handleOnAutoPlayChange}
            />
          </div>
        </Section>
      )}

      <Section size='small' bottomBorder>
        <ItemWrapper title='Products To Show'>
          <OriSelect
            size='large'
            value={productToShow}
            onChange={handleOnProductToShowChange}>
            <Option value={EResponsiveProductToShow.One}>
              One Product On Screen
            </Option>
            <Option value={EResponsiveProductToShow.TwoLandscape}>
              Two Products On Screen (Landscape)
            </Option>{' '}
            <Option value={EResponsiveProductToShow.TwoPortrait}>
              Two Products On Screen (Portrait)
            </Option>{' '}
            <Option value={EResponsiveProductToShow.Three}>
              Three Products On Screen
            </Option>{' '}
            {isConvertible ? (
              <React.Fragment></React.Fragment>
            ) : (
              <React.Fragment>
                <Option value={EResponsiveProductToShow.Four}>
                  Four Products On Screen
                </Option>{' '}
                <Option value={EResponsiveProductToShow.Five}>
                  Five Products On Screen
                </Option>{' '}
                <Option value={EResponsiveProductToShow.Six}>
                  Six Products On Screen
                </Option>
              </React.Fragment>
            )}
          </OriSelect>
        </ItemWrapper>
        {!isOneProductOnScreen && (
          <React.Fragment>
            <div className={css.gapContainer}>
              <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
                Leave gap between products
              </OriCheckbox>
            </div>
            <ItemWrapper title='Scrolled Out Products Number'>
              <OriSelect
                size='large'
                value={scrollOut}
                onChange={handleOnScrollOutChange}>
                {generateScrolledOut()}
              </OriSelect>
            </ItemWrapper>
          </React.Fragment>
        )}

        <ItemWrapper title='Call To Action Button Theme(Optional)'>
          <OriSelect
            size='large'
            value={actionButtonTheme}
            onChange={handleOnActionButtonThemeChange}>
            <OriSelect.Option value={null}>None</OriSelect.Option>
            {(buttons || []).map((i) => {
              return (
                <OriSelect.Option value={i.uuid} key={i.uuid}>
                  {i.name}
                </OriSelect.Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveText
                          hideBkgColor={shouldHideBkgColor}
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Products]: {
                    title: 'Products',
                    hasError: amountErr.length > 0,
                    child: (
                      <DragNDropColumns
                        // disabled={!isPrimary}
                        // hideAdd={!isPrimary}
                        hideTitle
                        childGenerate={childGenerate}
                        data={products}
                        droppableId={`salesChannelContentListProductCarousel${draggableId}`}
                        onSort={handleItemOnSort}
                        // hideAdd={hideAdd}
                        onAdd={() => {
                          setVisible(true);
                        }}
                        addText={'+ Add Product'}
                        onDelete={handleOnItemDelete}
                      />
                    ),
                  },
                }),
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsiveProductCarousel;
